var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon-round-button',_vm._g({staticClass:"mb-2 bg-warning",attrs:{"title":"Remove"}},_vm.$listeners),[_c('base-material-design-icon',{attrs:{"icon":"remove"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }